import { render, staticRenderFns } from "./imgText.vue?vue&type=template&id=e876c736&scoped=true"
import script from "./imgText.vue?vue&type=script&lang=js"
export * from "./imgText.vue?vue&type=script&lang=js"
import style0 from "./imgText.vue?vue&type=style&index=0&id=e876c736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e876c736",
  null
  
)

export default component.exports